import React, { useState, useRef } from 'react'
import { message } from 'antd'
import classNames from 'classnames'
import AssociateTaskModal from '../associateTaskModal'
import { getProjectSource } from '../../common/trackCommon'
import util from '../../utils/util'
import request from '../../utils/request'
import { PLATFORM_VALUE } from '../platformConfig'
import AddInspirationModal from '../addInspirationModal'
import onCollectNotification from './notification'
import notVisitedRecentlyModal from './notVisitedRecently'
import './index.less'

/**
 *
 * @onCollect 采集按钮点击事件
 * @currentBlog 当前所有需要的数据 其中 采集按钮会返回 currentBlog.item
 */

const Collect = (props) => {
  const userInfo = JSON.parse(sessionStorage.getItem('account')) || {}
  const {
    currentBlog,
    afterJoin,
    children,
    className,
    idList,
    itemIdList,
    beforeCollect,
    disabled,
    isCollectReport,
    onCollect,
    hasCurInstated,
    style,
  } = props

  const blogId = currentBlog?.imageGroupEntityId || currentBlog?.productId || currentBlog?.itemId

  const [visible, setVisible] = useState(false)
  const [itemInfo, setItemInfo] = useState({})

  const [taskConfirmVisible, setTaskConfirmVisible] = useState(false)
  const taskConfirmTemp = useRef(null)

  const fetchItemDetail = async () => {
    const res = await request.get(`v1-2-0/item/info?itemId=${currentBlog?.itemId}`)
    setItemInfo({
      platformId: Number(currentBlog?.platformId)
       || currentBlog?.mnPlatformType || (currentBlog?.goodsType === 100 ? PLATFORM_VALUE.DY : PLATFORM_VALUE.ITEM),
      price: res.price,
      imageGroupEntityId: blogId,
      itemDataDTO: {
        ...res,
        itemTitle: res.title,
        price: res.curCprice,
      }
    })
  }

  const selected = () => {
    if (idList) { return idList }
    return [...(itemIdList || []).map(m => ({
      blogId: m,
      platformId: m.mnPlatformType || currentBlog?.platformId,
      inspirationId: hasCurInstated ? m.inspirationId : null,
      styleTitle: m?.styleTitle,
    }))]
  }

  const _onCollect = async () => {
    if (disabled) return
    if (userInfo?.isWhalePick) {
      currentBlog?.itemId && await fetchItemDetail()
      setVisible(true)
      return
    }
    const flag = await beforeCollect?.()
    if (flag === false) { return }
    // 没有 isRecord 字段也可以采集,所以这里用 === false
    if (currentBlog?.isRecorded === false) {
      message.error('该商品暂时不支持采集')
      return
    }
    currentBlog?.itemId && await fetchItemDetail()
    setVisible(true)
    util.track('mn-collect-click', {})
    onCollect?.(currentBlog?.item)
    currentBlog?.itemId && util.track('collectgoods', { ...util.getTrackModule(), itemId: currentBlog?.itemId, itemName: currentBlog?.title })
  }

  const isNotVisitedRecently = useRef(true)
  const afterCompleteData = useRef({})
  const onTaskConfirmOk = () => {
    onTaskClose()
  }

  const onAssociateTask = (val) => {
    isNotVisitedRecently.current = false
    taskConfirmTemp.current = val
    setTaskConfirmVisible(true)
  }

  const onTaskClose = () => {
    isNotVisitedRecently.current = true
    notVisitedRecentlyModal({
      inspirationIdList: afterCompleteData.current.params.inspirationIdList,
      data: afterCompleteData.current?.data
    })
    setTaskConfirmVisible(false)
    afterJoin?.()
  }

  return <>
    <a
      className={classNames('collect-trigger', className)}
      onClick={(e) => {
        e.stopPropagation()
        _onCollect()
      }}
      style={style}
    >
      {children || '采集'}
    </a>
    {visible ? <span onClick={e => e.stopPropagation()}>
      <AddInspirationModal
        visible={visible}
        onClose={() => { // 采集关闭
          setVisible(false)
        }}
        hasCurInstated={hasCurInstated}
        currentViewBlog={{ ...currentBlog, ...itemInfo, isCollectReport }}
        afterJoin={(_afterCompleteData) => { // 采集完成后
          afterCompleteData.current = _afterCompleteData
          onCollectNotification()
          if (isNotVisitedRecently.current) {
            notVisitedRecentlyModal({
              inspirationIdList: afterCompleteData.current?.params?.inspirationIdList,
              data: afterCompleteData.current?.data
            })
          }
          util.track('mn-add-style', {
            module1: getProjectSource(),
            module2: '采集'
          })
          util.track('mn-add-style-click', {})

          if (_afterCompleteData?.params) {
            if (_afterCompleteData.params?.tagNameList?.length) {
              util.track('mn-collect-modal-from', { module1: '标签' })
            }
            if (_afterCompleteData.params?.price) {
              util.track('mn-collect-modal-from', { module1: '参考价格' })
            }
            if (_afterCompleteData.params?.description) {
              util.track('mn-collect-modal-from', { module1: '描述' })
            }
            if (_afterCompleteData.params?.gender) {
              util.track('mn-collect-modal-from', { module1: '行业' })
            }
          }
          if (!taskConfirmTemp.current) {
            afterJoin?.()
          }
        }}
        onAssociateTask={onAssociateTask}
        batchSelected={selected()}
        userInfo={userInfo}
      />
    </span> : null}

    {
        taskConfirmVisible && <AssociateTaskModal
          visible={taskConfirmVisible}
          collectId={taskConfirmTemp.current?.collectIdList?.[0] || taskConfirmTemp.current?.collectId}
          onClose={() => {
            onTaskClose()
          }}
          onOk={() => onTaskConfirmOk()}
        />
      }
  </>
}

export default Collect
